<template>
  <v-container class="event-dashboard" grid-list-md>
    <v-layout row>
      <v-flex class="my-5">
        <h1>Event Dashboard</h1>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex md6 class="my-5">
        <v-card>
          <v-toolbar color="green" dark>
            <v-toolbar-title>
              Manage Events
            </v-toolbar-title>
          </v-toolbar>
          <v-list>
            <v-list-tile @click="createNew()">
              <v-list-tile-action>
                <v-icon color="primary">star</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title v-text="'Create new event'"></v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-subheader inset>
              Existing projects
            </v-subheader>
            <v-divider inset></v-divider>

            <v-list-tile
              v-for="event in events"
              :key="event.uri"
              @click="handleLink(`/admin/createEvent/${event.id}`)"
            >
              <v-list-tile-action>
                <v-icon color="primary" v-if="event.publish">turned_in</v-icon>
                <v-icon color="primary" v-if="!event.publish">turned_in_not</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title v-text="event.title"></v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

          </v-list>
        </v-card>
      </v-flex>

      <v-flex md6 class="my-5">
        <v-card>
          <v-toolbar color="green" dark>
            <v-toolbar-title>
              Event Stats
            </v-toolbar-title>
          </v-toolbar>
          <v-list>

            <v-subheader>
              Attendance by Year
            </v-subheader>
            <v-list-tile
              v-for="(amount, index) in attendance"
              :key="index"
            >
              <v-list-tile-content>{{ index }}</v-list-tile-content>
              <v-list-tile-content class="align-end">{{ amount }}</v-list-tile-content>
            </v-list-tile>

            <v-divider></v-divider>

            <v-list-tile>
              <v-list-tile-title v-text="'More coming soon'"></v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import { db, storage, CurrentTime } from '@/db.js'

export default {
  name: 'eventIndex',
  data () {
    return {
      events: []
    }
  },
  computed: {
    attendance () {
      let output = {}
      let eventList = this.events || []

      eventList.map((event) => {
        let year = event.start.split('-')[0]
        const currentYear = output[year] > 0 ? output[year] : 0
        const eventAttendance = event.eventAttendance > 0 ? event.eventAttendance : 0
        output[year] = currentYear + eventAttendance
      })
      return output
    }
  },
  methods: {
    createNew () {
      this.handleLink(`/admin/createEvent/`)
    },
    handleLink (url) {
      let urlPattern = new RegExp(
        '^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$' + // fragment locator
          '',
        'i' + '' // string to match
      )
      const isUrl = urlPattern.test(url)

      if (isUrl) {
        window.open(url)
      } else {
        this.$router.push(url)
      }
    }
  },
  firestore: {
    events: db.collection('events').orderBy('start')
  }
}
</script>
